'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */

var ALREADY_VERIFIED = exports.ALREADY_VERIFIED = 'Already Verified';
var CODE_ERROR = exports.CODE_ERROR = 'phone_verification_code_error';
var CODE_LENGTH = exports.CODE_LENGTH = 4;
var DELIVERY_METHOD_SMS = exports.DELIVERY_METHOD_SMS = 'sms';
var DELIVERY_METHOD_VOICE = exports.DELIVERY_METHOD_VOICE = 'voice';
var DUPLICATE_NUMBER = exports.DUPLICATE_NUMBER = 'Duplicate Number';
var DUPLICATE_NUMBER_ERROR = exports.DUPLICATE_NUMBER_ERROR = 'phone_verification_duplicate_error';
var ERROR_CODE_MAPPING = exports.ERROR_CODE_MAPPING = {
  400: 'Please provide a valid phone number.',
  403: 'This code is incorrect, please try again.',
  429: 'You’ve exceeded the maximum number of verification attempts in this period. Please wait an hour and try again.'
};